import { createSlice } from "@reduxjs/toolkit";
import { Access } from "../usePageAccessHook";
import * as constants from "./constants";

export const slice = createSlice({
  name: "userAccess",
  initialState: {
    [constants.MENU_ITEMS]: [],
    [constants.REDIRECT_URL]: "/",
    [constants.MENU_ITEMS_LOADING]: false,
    [constants.ORG_UNITS]: [],
    [constants.ORG_UNITS_LOADING]: false,
    [constants.TAB_NAV]: [],
    access: {
      path: "/dashboard",
      rights: Access.WRITE,
    },
    [constants.USER_DETAILS]: {},
    [constants.FIELDS]: {
      customer_assortment: {},
      customer_hierarchy: {},
      customer_notes: {},
      customer_reports: {},

      //master data -> articles
      article_flavor: {},
      article_pack_size: {},
      article_pack_type: {},
      article_barcode: {},
      article_EAN: {},
      article_unit_of_measure: {},
      article_weight: {},
      article_dimension: {},
      article_price: {},
      article_planogram_builder: {},

      //Asset management -> asset models
      asset_serial_number: {},
      asset_barcode: {},
      asset_assortment: {},
      smart_asset: {},
      asset_primary_planogram: {},
      asset_model_dimensions: {},
      asset_model_number_of_doors: {},
      asset_model_number_of_shelves: {},
      asset_model_power: {},
      asset_model_price: {},
  
      //IR Onboarding
      IR_products_flavor: {},
      IR_products_pack_size: {},
      IR_products_pack_type: {},
      IR_products_category: {},
      IR_products_dimensions: {},

      //Survey
      survey_scoring: {},
      survey_copy_last: {},

      //Common
      customer_equipment: {},
      customer_classification: {},
      customer_wholesalers: {},
      customer_documents: {},
      promotions: {},
      orders_copy_previous: {},
    },
  },
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.payload.error}`;
      state[action.payload.callType] = false;
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === constants.MENU_ITEMS_LOADING) {
        state[constants.MENU_ITEMS] = [];
        state[constants.MENU_ITEMS_LOADING] = true;
      } else if (action.payload.callType === constants.SUB_MENU_ITEMS_LOADING) {
        state[constants.MENU_ITEMS_LOADING] = true;
      }
    },
    startTabNavCall: (state, action) => {
      state.error = null;
      state[constants.TAB_NAV] = [];
    },
    setTabMenuItems: (state, action) => {
      const { items } = action.payload;
      state[constants.TAB_NAV] = items;

    },
    setUserAccess: (state, action) => {
      state.access = action.payload;
    },
    setUserOrgUnits: (state, action) => {
      state.organizationUnits = action.payload;
    },
    setUserMenus: (state, action) => {
      state.menu = action.payload;
    },
    setRedirectUrl: (state, action) => {
      state.redirectUrl = action.payload;
    },
    setUserFields: (state, action) => {
      state[constants.FIELDS] = action.payload;
    },
    customItemsFetched: (state, action) => {
      const { entities, entitiesProp, loadingProp } = action.payload;

      state[entitiesProp] = entities;
      state[loadingProp] = false;
      state.error = null;
    },
    fetchSubMenuItems: (state, action) => {
      const { menuID, items } = action.payload;
      state[constants.MENU_ITEMS] = LoadItems(menuID, state[constants.MENU_ITEMS], items);
      state[constants.MENU_ITEMS_LOADING] = false;
      state.error = null;
    },
    setUserDetails: (state, action) => {
      state[constants.USER_DETAILS] = action.payload;
    }
  },
});

function LoadItems(menuID, menuItems, subMenuItems) {
  return menuItems.map(menuItem => {
    if (menuItem.id === menuID) {
      return { ...menuItem, items: subMenuItems };
    } else {
      if (menuItem.items && menuItem.items.length > 0)
        return {
          ...menuItem,
          items: LoadItems(menuID, menuItem.items, subMenuItems),
        };
      else return menuItem;
    }
  });
}
